import type React from "react";
import type { CloudflareEnvironment } from "../types/index.js";

interface HardGateBannerProps {
  currentEnv: CloudflareEnvironment;
  onSwitchEnv: (env: "Production" | "Staging") => void;
}

export const HardGateBanner: React.FC<HardGateBannerProps> = ({
  currentEnv,
  onSwitchEnv,
}) => {
  const isProd = currentEnv.name === "Production";

  return (
    <div
      style={{
        padding: "12px 20px",
        backgroundColor: isProd ? "#1e1e24" : "#1a2332",
        borderBottom: `2px solid ${isProd ? "#ef4444" : "#3b82f6"}`,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        color: "#ffffff",
        fontSize: "13px",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
        <span
          style={{
            fontWeight: 700,
            textTransform: "uppercase",
            letterSpacing: "0.05em",
            padding: "2px 8px",
            borderRadius: "4px",
            backgroundColor: isProd ? "#ef4444" : "#3b82f6",
            color: "#ffffff",
          }}
        >
          {currentEnv.name}
        </span>
        <span>
          <strong>Target Cloudflare Account ID:</strong>{" "}
          <code
            style={{
              backgroundColor: "rgba(255, 255, 255, 0.1)",
              padding: "2px 6px",
              borderRadius: "3px",
              fontFamily: "monospace",
            }}
          >
            {currentEnv.accountId}
          </code>
        </span>
        <span
          style={{
            color: "#10b981",
            display: "flex",
            alignItems: "center",
            gap: "4px",
          }}
        >
          ✓ Hard Gate Enforced (Zero Cross-Account Execution)
        </span>
      </div>

      <div style={{ display: "flex", gap: "8px" }}>
        <button
          type="button"
          onClick={() => onSwitchEnv("Production")}
          style={{
            padding: "4px 10px",
            fontSize: "12px",
            fontWeight: isProd ? 600 : 400,
            backgroundColor: isProd ? "#ef4444" : "transparent",
            color: "#ffffff",
            border: "1px solid #ef4444",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Production (be728a3f)
        </button>
        <button
          type="button"
          onClick={() => onSwitchEnv("Staging")}
          style={{
            padding: "4px 10px",
            fontSize: "12px",
            fontWeight: !isProd ? 600 : 400,
            backgroundColor: !isProd ? "#3b82f6" : "transparent",
            color: "#ffffff",
            border: "1px solid #3b82f6",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Staging (944fa030)
        </button>
      </div>
    </div>
  );
};
